<template>
    <div class="w-full p-4">
        <CorrectIncorrectIcon :is-correct="true" />
        <span>{{ question.correct_answer }}</span>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionOrderPhraseViewOnly',
    components: {
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
